import styled from "styled-components";
import { Col as AntdCol, Layout } from "antd";
import { Button as StyledButton, Button2 } from "../../styles/buttons";

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const TableContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
  }

  .ant-pagination-item,
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
    display: none;
  }
`;

export const Button = styled(Button2)`
  margin-top: -1px;
  border-radius: 20px;
  width: fit-content;
`;

export const Form = styled.form``;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Col = styled(AntdCol)`
  width: 12.4rem;
  margin-bottom: 0.8rem;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

    &:focus,
    &:hover {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 768px) {
    min-width: 0em;
  }
`;

export const ResponsiveTable = styled.div``;

export const ResponsiveRow = styled.div`
  display: flex;
  margin: 0 12px 12px 0;
  justify-content: space-between;
  padding: 5px;

  text-align: center;
  align-items: center;
  align-content: space-between;

  border-radius: 8px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ResponsiveColumn = styled.div`
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;

  padding-top: 2px;
  padding-right: 2px;
`;

export const ConfirmationModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  width: 90vw;
  max-width: 1400px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;

  h2 {
    width: fit-content;
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ValueCard = styled.div`
  display: flex;
  justifycontent: space-between;
  width: 100%;

  div {
    text-align: center;
    margin-right: 20px;
    border-radius: 8px;
    background-color: white;
    padding: 10px;
    height: 110px;
    width: 145px;
    border: 1px solid rgba(92, 92, 92, 0.22);
    box-shadow: 1px 2px 9px rgba(92, 92, 92, 0.55);
  }

  @media (max-width: 940px) {
    flex-wrap: wrap;
    height: auto;
    align-content: space-around;
    justify-content: center;

    div {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      margin-right: 4px;
    }
  }
`;

export const TextGroup = styled.div`
  margin-bottom: 10px;
`;

export const Description = styled.text`
  font-size: 16px;
  font-weight: bold;
  color: black;
`;

export const Item = styled.text`
  margin-left: 10px;
  font-size: 16px;
  color: black;
`;

export const ModalContent = styled.div`
  margin-top: 15px;
`;

export const GridContainer = styled.div`
  width: 100%;
  overflow: auto;
  max-height: 60vh;
`;

export const HistoryGridRow = styled.div<{ header?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #f0f0f0;
  background-color: ${(props) => (props.header ? "#fafafa" : "transparent")};
  font-weight: ${(props) => (props.header ? "600" : "normal")};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) => (props.header ? "#fafafa" : "#f5f5f5")};
  }
`;

export const BankGridRow = styled.div<{ header?: boolean }>`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  border-bottom: 1px solid #f0f0f0;
  background-color: ${(props) => (props.header ? "#fafafa" : "transparent")};
  font-weight: ${(props) => (props.header ? "600" : "normal")};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) => (props.header ? "#fafafa" : "#f5f5f5")};
  }
`;

export const GridHeader = styled.div`
  padding: 8px 6px;
  font-weight: 600;
  border-right: 1px solid #f0f0f0;
  min-width: 90px;
  font-size: 13px;

  &:last-child {
    border-right: none;
  }
`;

export const GridCell = styled.div`
  padding: 8px 6px;
  border-right: 1px solid #f0f0f0;
  min-width: 90px;
  word-break: break-word;
  font-size: 13px;

  &:last-child {
    border-right: none;
  }
`;
